angular
  .module('zc.projects.campaigns')
  .config(routerConfig);

routerConfig.$inject = ['$stateProvider'];

function routerConfig($stateProvider) {
  $stateProvider
    .state('admin.projects.dashboard', {
      url: '/dashboard',
      views: {
        'content@': {
          template: '<zc-dashboard project="$resolve.currentProject"></zc-dashboard>'
        }
      }
    });
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.dashboard/routes.js